import { AppService } from './../core/app.service';
import { Injectable } from "@angular/core";
import { AbstractService } from "../core/AbstractService";
import { ExpressionBesoinReq } from "../data/http/requests/expression.req";
import { ExpressionBesoinRes } from "../data/http/responses/expression.res";
import { HttpClient } from "@angular/common/http";
import { env } from "../../env/env";
import { ActiviteService } from "./activite/activite.service";
import { catchError, Observable } from "rxjs";
import { ApiResponse } from "../data/http/responses/apiresponse.response";

@Injectable({
    providedIn: 'root'
})
export class ExpressionBesoinService extends AbstractService<ExpressionBesoinReq, ExpressionBesoinRes> {
    constructor(http: HttpClient, AppService: AppService) {
        super(`${env.apiUrl}expression-besoin-marche`, http, AppService); 
    }

    getAllByAppIdExcludeRegroupement(appId: string): Observable<ApiResponse<ExpressionBesoinRes[]>> {
        return this.http.get<ApiResponse<ExpressionBesoinRes[]>>(
            `${env.apiUrl}expression-besoin-marche/by-app-id-exclude-regroupement/${appId}`,
            { headers: this.getHeaders() }
        ).pipe(
            catchError(this.handleError) // Utilise la gestion d'erreur de la classe abstraite
        );
    }
}